import { render, staticRenderFns } from "./SubjectSearchDialog.vue?vue&type=template&id=4aa8512e"
import script from "@/views/Users/Teacher/SubjectSearchDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Teacher/SubjectSearchDialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports